module.exports = __webpack_public_path__ + "img/keyboard-brightness.23306a3e.svg";